import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type DocumentImage } from '../hooks/useFetchArchivedDocumentImages'

export type DeleteButtonProps = {
  documentImage: DocumentImage
}

export const DeleteButton = ({ documentImage }: DeleteButtonProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', documentImage })
  }, [documentImage, setDialogInfo])

  return (
    <StyledButton
      disabled={!documentImage.figureMeta.isDeletable}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    >
      {t('delete_forever')}
    </StyledButton>
  )
}
